class DeliveryEstimate extends HTMLElement {
  static DAY = 86400000;
  static DAY_NAMES = ['v neděli', 'v pondělí', 'v úterý', 've středu', 've čtvrtek', 'v pátek', 'v sobotu'];
  static FIXED_HOLIDAYS = ['1-1', '5-1', '5-8', '7-5', '7-6', '9-28', '10-28', '11-17', '12-24', '12-25', '12-26'];

  connectedCallback() {
    const target = this.querySelector('u') || this;
    target.textContent = this.estimate();
  }

  estimate() {
    const cutoff = Number(this.dataset.cutoff || 12);
    const now = this.pragueNow();
    const today = Date.UTC(now.year, now.month - 1, now.day);

    let ship = today;
    if (now.hour >= cutoff || !this.isWorkday(ship)) {
      do {
        ship += DeliveryEstimate.DAY;
      } while (!this.isWorkday(ship));
    }

    let delivery = ship + DeliveryEstimate.DAY;
    while (!this.isWorkday(delivery)) {
      delivery += DeliveryEstimate.DAY;
    }

    const date = new Date(delivery);
    const daysFromToday = (delivery - today) / DeliveryEstimate.DAY;
    let prefix;
    if (daysFromToday === 1) {
      prefix = 'zítra';
    } else if (daysFromToday === 2) {
      prefix = 'pozítří';
    } else {
      prefix = DeliveryEstimate.DAY_NAMES[date.getUTCDay()];
    }
    return `${prefix} ${date.getUTCDate()}. ${date.getUTCMonth() + 1}.`;
  }

  pragueNow() {
    const parts = new Intl.DateTimeFormat('en', {
      timeZone: 'Europe/Prague',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      hourCycle: 'h23',
    }).formatToParts(new Date());
    const value = (type) => Number(parts.find((part) => part.type === type).value);
    return { year: value('year'), month: value('month'), day: value('day'), hour: value('hour') };
  }

  isWorkday(timestamp) {
    const date = new Date(timestamp);
    const weekday = date.getUTCDay();
    if (weekday === 0 || weekday === 6) return false;
    return !this.isHoliday(date);
  }

  isHoliday(date) {
    const key = `${date.getUTCMonth() + 1}-${date.getUTCDate()}`;
    if (DeliveryEstimate.FIXED_HOLIDAYS.includes(key)) return true;
    const easter = this.easterSunday(date.getUTCFullYear());
    const timestamp = date.getTime();
    return timestamp === easter - 2 * DeliveryEstimate.DAY || timestamp === easter + DeliveryEstimate.DAY;
  }

  easterSunday(year) {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return Date.UTC(year, month - 1, day);
  }
}

customElements.define('delivery-estimate', DeliveryEstimate);
